/** How far an `<img>` got: still waiting, decoded, or failed. */
export type ImageLoadOutcome = 'pending' | 'load' | 'error';

/** What the transcript should draw for that outcome. */
export type ImageLoadPhase = 'loading' | 'ready' | 'unavailable';

/**
 * A missing src is unavailable immediately, so nothing mounts an `<img>` with an
 * empty source (the browser's broken-image icon). A load error is the same
 * settled state. A real src stays loading until `load`.
 */
export function imageLoadPhase(src: string | null | undefined, outcome: ImageLoadOutcome): ImageLoadPhase {
  if (typeof src !== 'string' || src.trim() === '') {
    return 'unavailable';
  }
  if (outcome === 'error') {
    return 'unavailable';
  }
  if (outcome === 'load') {
    return 'ready';
  }
  return 'loading';
}

/**
 * The card thumb keeps its spinner while the piece is still resolving (`waiting`),
 * even if the file 404s, because a processing upload often has no bytes yet.
 * Once that wait is over, a missing src or a failed load is the fallback:
 * text, not a spinner and not a broken icon.
 */
export function showImageFallback(phase: ImageLoadPhase, waiting: boolean): boolean {
  if (waiting) {
    return false;
  }
  return phase === 'unavailable';
}
